// @ts-nocheck
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { ProductContext } from "@insite/client-framework/Components/ProductContext";
import translate from "@insite/client-framework/Translate";
import { ProductModel } from "@insite/client-framework/Types/ApiModels";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import ListItem, { UnorderedList } from "@insite/mobius/Lists";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import React, { useContext } from "react";
import { css } from "styled-components";

interface OwnProps {
    product: ProductModel;
}
export interface SupersededByStyles {
    wrapper?: InjectableCss;
    widgeTitle?: TypographyProps;
    productList?: InjectableCss;
    productListItem?: InjectableCss;
    productLink?: LinkPresentationProps;
}

export const supersededByStyles: SupersededByStyles = {
    wrapper: {
        css: css`
            color: ${getColor("warning.main")};
            border: 1px solid ${getColor("warning.main")};
            padding: ${pxToRem(14)};
            margin-bottom: 1em;
        `,
    },
    widgeTitle: {
        color: "text.main",
        as: "strong",
    },
    productList: {
        css: css`
            color: ${getColor("warning.main")};
            padding-top: ${pxToRem(7)};
            padding-left: ${pxToRem(14)};
        `,
    },
    productListItem: {
        css: css`
            color: ${getColor("warning.main")};
        `,
    },
    productLink: {
        css: css`
            color: ${getColor("warning.main")};
            text-decoration: underline;

            &:hover {
                text-decoration: none;
            }
        `,
    },
};
const styles = supersededByStyles;

type Props = OwnProps;

const SupersededByComponent = ({ product }: Props) => {
    if (!product.properties.supersededBy) {
        return null;
    }
    const supersedes = JSON.parse(product.properties?.supersededBy);
    return (
        <StyledWrapper {...styles.wrapper}>
            <Typography>{translate("Store_ProductDetail_Superseded_Warning")}</Typography>
            <UnorderedList {...styles.productList}>
                {supersedes.map((supersede: { ErpNumber: string; ProductName: string; Url: string }) => (
                    <ListItem {...styles.productListItem} key={supersede.ErpNumber}>
                        <Link href={supersede.Url} {...styles.productLink}>
                            {supersede.ErpNumber}&nbsp;-&nbsp;{supersede.ProductName}
                        </Link>
                    </ListItem>
                ))}
            </UnorderedList>
        </StyledWrapper>
    );
};

export default SupersededByComponent;
